import { ProviderFragment } from '../../../generated/graphql'
import { providerProperties } from '../../../provider/provider-properties'
import { Provider } from '../common/Provider'

const MAXIMUM_PRIORITY = 9999

function getProviderPriority(provider: ProviderFragment | Provider) {
  return provider.isFallback
    ? MAXIMUM_PRIORITY
    : providerProperties[provider.type].priority
}

export function sortProvidersByPriority(
  a: ProviderFragment | Provider,
  b: ProviderFragment | Provider,
): number {
  const result = getProviderPriority(a) - getProviderPriority(b)

  return result === 0
    ? new Date(a.createdAt).valueOf() - new Date(b.createdAt).valueOf()
    : result
}
